import { BrowserUpdated, CarRentalRounded, ContactMail, Facebook, Home, LinkedIn, Mail, Phone } from '@mui/icons-material'
import { Box, IconButton } from '@mui/material'
import { Button } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'
import Logo from "../Files/IBG Logo without background.svg"

interface Props { }

function TopHeader(props: Props) {
    const { } = props

    function goTo(link: string) {
        window.open(link)
    }

    return (
        <div>
            <div className='topHeader'>
                <Box alignSelf={"center"}  >
                    <Button size='small' style={{ padding: "15px", backgroundColor: "#164F7D", borderTop: "0px solid", borderBottom: "0px solid", borderRadius: "0px", color: "rgb(255, 255, 255)" }}><LinkedIn style={{ fontSize: "20px" }} /></Button>
                    <Button size='small' style={{ padding: "15px", backgroundColor: "#164F7D", borderTop: "0px solid", borderBottom: "0px solid", borderRadius: "0px", color: "rgb(255, 255, 255)" }}><Facebook style={{ fontSize: "20px" }} /></Button>
                    <Button size='small' style={{ padding: "15px", backgroundColor: "#164F7D", borderTop: "0px solid", borderBottom: "0px solid", borderRadius: "0px", color: "rgb(255, 255, 255)" }} icon={<Phone style={{ fontSize: "20px" }} />}>(+237) 690 767 963</Button>
                    <Button size='small' style={{ padding: "15px", backgroundColor: "#164F7D", borderTop: "0px solid", borderBottom: "0px solid", borderRadius: "0px", color: "rgb(255, 255, 255)" }} icon={<Mail style={{ fontSize: "20px" }} />}>contact@ibgalphatech.com</Button>
                </Box>
            </div>
        </div>
    )
}

export default TopHeader
